import React, { FC, useCallback, useState } from "react";
import {
    IControlMeasure,
    IControlMeasureAssessment,
    IDocument,
    IProjectFailureMode,
    IRiskAssessment
} from "../types/types";
import {
    Button,
    Dialog,
    Checkbox,
    DialogActions,
    DialogContent,
    DialogTitle, TextField,
    FormControlLabel,
    Typography
} from "@material-ui/core";


import DialogContentText from "@material-ui/core/DialogContentText";
import Documents from "./documents";
import { CheckBox, Label } from "@material-ui/icons";

interface IRiskAssessmentProps {
    controlMeasure: IControlMeasure
    project_falure_mode_id?: number
    updateControlMeasure: (controlMeasure: IControlMeasure, project_falure_mode_id?:number) => void;
    closeDialogCallback: () => void;

}

const AddControlMeasureDialog: FC<IRiskAssessmentProps> = ({
    controlMeasure,
    closeDialogCallback,
    project_falure_mode_id,
    updateControlMeasure }) => {

    const [newControlMeasure, setNewControlMeasure] = useState<IControlMeasure>(controlMeasure);


    const renderField = <T,>(obj: T, key: keyof T,
        label: string,
        type: string,
        setObj: (obj: T) => void) => {
        return <div>
            <div style={{
                width: "100%",
                margin: "auto",
            }}>
                <TextField
                    fullWidth
                    label={label}
                    value={obj[key]}
                    onChange={(event) => {
                        let v = (event.target.value as string);

                        let c = { ...obj } as T;
                        if (type === "string") {
                            (c as any)[key] = v
                        }
                        if (type === "number") {
                            (c as any)[key] = parseFloat(v)
                        }
                        setObj(c)
                    }
                    }
                    type={type}
                />
            </div>
        </div>
    }


    const [documentRef, setDocumentRef] = useState<IDocument>(() => {
        if (controlMeasure.document) {
            return controlMeasure.document
        }
        return {}
    }

    );

    const updateDocumentSelection = useCallback((documentRef: IDocument) => {
        setDocumentRef(documentRef)

    }, [setDocumentRef]);



    const submitControlMeasure = () => {
        let ra = { ...newControlMeasure }
        if (documentRef?.id) {
            ra["document_id"] = documentRef.uuid;
        }
        if (project_falure_mode_id) {
            updateControlMeasure(ra, project_falure_mode_id)
        } else {
            updateControlMeasure(ra)
        }
        closeDialogCallback()
    }

    return (<Dialog open={true} onClose={closeDialogCallback} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Add Control Measure</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Add Control Measure
            </DialogContentText>
            {renderField<IControlMeasure>(newControlMeasure,
                "description",
                "Name",
                "string", setNewControlMeasure)}

            {renderField<IControlMeasure>(newControlMeasure,
                "comment",
                "Description",
                "string", setNewControlMeasure)}
            <FormControlLabel
                label="Existing"

                control={<Checkbox checked={newControlMeasure.existing}
                    onChange={(event) => {

                        let c = { ...newControlMeasure }
                        c.existing = event.target.checked
                        setNewControlMeasure(c)
                    }
                    } />
                }
            />


            <Documents updateDocumentID={updateDocumentSelection} />

        </DialogContent>
        <DialogActions>
            <Button onClick={closeDialogCallback} color="primary">
                Cancel
            </Button>
            <Button onClick={submitControlMeasure} color="primary">
                Submit
            </Button>
        </DialogActions>
    </Dialog>
    )
}

export default AddControlMeasureDialog;
